import React, { Component } from 'react';
import "../../CommonStyles/CSS.css";
import './Cart.css';
//import dvas from '../../images/public/registeration/dvas.png';
//import clos from '../../images/public/registeration/clos.png';
//import back from '../../images/public/registeration/back.png';
import noImage from '../../images/public/noImage.png';
import help from '../../images/public/userarea/tab5u.png';
//import crdscia from '../../images/public/userarea/crdscia.png';
//import stck from '../../images/public/login/stck.png';
import logo from '../../images/public/login/logo.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { isBrowser } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
import { BrowserRouter as Router } from "react-router-dom";
//import Configminore from '../Configminore/Configminore';
import AlertPnl from "../../assets/components/panel/AlertPnl";
import tr from '../../libs/tr';
//import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
//import { addToCart } from '../../libs/fetch'
import Cookies from 'universal-cookie';
import WaitLoad from "../../assets/components/loading/WaitLoad";
//import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
// import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
import InfoModal from "../../assets/components/Modal/Modal";
import MPWorkFlow from "../../libs/workflow";
import { HtmlWrapper } from '../../Utils';
// const stageName = "Cart";
//import itabar2 from '../../images/public/registeration/nav2i.png';
//import engbar2 from '../../images/public/registeration/nav2e.png';
//import simplebar2 from '../../images/public/registeration/mobilenav2.png';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
import TopBar from '../../assets/components/topbar/TopBar';
import CardSki1 from '../../images/public/registeration/CardSki1.svg';
import CardSki2 from '../../images/public/registeration/CardSki2.svg';
import miniArrow from '../../images/public/registeration/miniarrow.png';

const cookies = new Cookies();

class Cart extends Component {
  constructor(props) {
    super(props);

    //let params = null;
    //console.log('[Cart]', params);

    this.state = {
      // isLoading: false,
      step: '2',
      errmsg: null,
      errorFlg: false,
      workFlowInProgress: false, //used by workflow.js services to ensure data avaiability before next screen
      screenData: null,
      userOptions: [],
      canProceed: false,
      helpShow: false,
      helpMessage: "",
      alertElimination: false,
      hidePay: false,
    };
  }

  componentDidMount() {
    // this.init();
    // this.wf = new MPWorkFlow();
    this.refresh();//TODO: change this to refresh
  }

  async init() {
    // update screenData for current states
    await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Cart"));
    this.update();
  }

  async update() {
    // updating server state...
    let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: this.state.screenData });
    //console.log('[Cart] @update #resp', resp);
    //console.log("resp status --> ",resp.status);
    if (!resp) return;
    if (resp.status === "success") {
      // updating localStorage
      MPWorkFlow.getInstance().updateWorkflow(this, resp.data);
      // updating current screen
      this.refresh();
    } /*
		else if (resp.status === "fail") {
				console.log("CIAO")
				this.setState({ canProceed: false, errorFlg: true, errmsg: resp.message, alertElimination: false});
		}*/
  }

  async refresh() {
    // update screenData for current states
    await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Cart"));

    this.setState({ canProceed: this.state.screenData.link_next !== "" });

    // check if there's a coupon then if there's error show it
    //let couponCode = document.getElementById("cart-coupon-code").value;
    //let error = this.state.screenData.error;
    // if (couponCode && error) {
    //     this.setState({ errorFlg: true, errmsg: error });
    // }
    // setting coupon label
    this.setCouponValue();
    // sorting user's options
    this.orderUserOptions();
    // sorting totals info
    this.orderUserTotals();
  }

  convertToISO88591(payloadString) {
    const iso88591Payload = payloadString.replace(/[^\x00-\xFF]/g, (char) => {
      return `&#${char.charCodeAt(0)};`;
    });
    return iso88591Payload;
  }

  preparePostData = (payload) => {
    const payloadString = Object.keys(payload)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`)
      .join('&');
    const iso88591Payload = this.convertToISO88591(payloadString);

    return iso88591Payload;
  };

  async transit(toWhere) {
    localStorage.setItem('isNexi', true);
    let price_info = {
      info: this.state.screenData.totals,
      priceToPay: this.state.screenData.total_amount
    }
    localStorage.setItem("price_info", JSON.stringify(price_info));
    let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });

    if (!resp || !resp.pay_response) return;
    if (resp.status === "success") {
      if (resp.pay_response.status === 'fail_credit_card' && resp.pay_response.method === 'POST') {
        const postUrl = resp.pay_response.paymentUrl;
        const postData = this.preparePostData(resp.pay_response.post_data);

        const iframe = document.createElement('iframe');

        if (window.innerWidth <= 480) {
          iframe.style.position = 'fixed';
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.top = '50%';
          iframe.style.left = '50%';
          iframe.style.transform = 'translate(-50%, -50%)';
          iframe.style.borderRadius = '0';
          iframe.style.margin = '0';
          iframe.style.padding = '0';
          iframe.style.zIndex = '9999';
        } else {
          iframe.style.width = '60%';
          iframe.style.height = '80%';
          iframe.style.position = 'fixed';
          iframe.style.top = '60%';
          iframe.style.left = '50%';
          iframe.style.transform = 'translate(-50%, -50%)';
          iframe.style.borderRadius = '20px';
          iframe.style.zIndex = '9999';
          iframe.style.border = 'none';
        }

        document.body.appendChild(iframe);

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = postUrl;
        form.target = iframe.name;

        const formData = new URLSearchParams(postData);

        formData.forEach((value, key) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        iframe.contentWindow.document.body.appendChild(form);
        window.addEventListener('message', (event) => {
          try {
            const data = JSON.parse(event.data);
            console.log('Received message from iframe:', data);
            localStorage.setItem('nexiPaymentStatus', data.status);
            let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
            console.log("[Cart] @transit #getRouteName:", nextScreen);
            MPWorkFlow.getInstance().updateWorkflow(this, resp.data);

            setTimeout(() => {
              this.props.history.push('/transaction-confirm');
              iframe.remove();
            }, 10000);
          } catch (e) {
            console.error('Error parsing message from iframe:', e);
          }
        });

        this.setState({ workFlowInProgress: true });
        form.submit();
        setTimeout(() => {
          this.setState({ hidePay: true }, () => {
            this.setState({ iframe: iframe, showIframe: true, workFlowInProgress: false });
          });
        }, 5000);
        
      } else {
        localStorage.setItem('isNexi', false);
        // updating localStorage and navigating to the new screen
        MPWorkFlow.getInstance().updateWorkflow(this, resp.data);
        let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
        console.log("[Cart] @transit #getRouteName:", nextScreen);
        if (this.state.screenData.link_next === 'Pay') {
          if (typeof window._fbq === 'function') {
            window._fbq('track', 'InitiateCheckout', {
              currency: 'EUR',
              value: this.state.screenData.total_amount
            });
          }
        }
        // console.log("[WelcomeScreen] @gotoResorts #getRouteName:", nextScreen);
        return this.props.history.push(nextScreen);
      }
    }
  }

  alertResponse(info) {
    //console.log(info);
    switch (info.type) {
      case "closeButton":
        this.setState({ errorFlg: false, alertElimination: false })
        break;
      case "actionButton":
        if (info.option1 === "attention") {
          this.setState({ errorFlg: false })
          break;
        }
        if (info.option1 === "eliminate") {
          this.setState({ errorFlg: false, alertElimination: false });
          this.deleteSkier(this.state.skierToBeDeleted)
          break;
        }
    }
  }
  /* new functions for new flow */

  setCouponValue() {
    document.getElementById("cart-coupon-code").value = this.state.screenData.coupon;
  }

  // orders user's options by 'order' key inside 'options' object of screenData
  orderUserOptions() {
    // NOTE: each time an option changes, this function must be called after modifyWorkflow() call
    // order the options
    let options = Object.values(this.state.screenData.options).sort((x, y) => x.order - y.order);
    // console.log("[Cart] @orderUserOptions #options:", options);
    this.setState({ userOptions: options });
  }
  // orders user's options by 'order' key inside 'options' object of screenData
  orderUserTotals() {
    // NOTE: each time an option changes, this function must be called after modifyWorkflow() call
    // order the options
    let totals = Object.values(this.state.screenData.totals).sort((x, y) => x.order - y.order);
    // console.log("[Cart] @orderUserOptions #options:", options);
    this.setState({ userTotals: totals, userTotalsLastIndex: totals.length - 1 });;
  }

  onUserOptionChanged = (id) => {
    let index = Number(id.split("-")[2]);
    // console.log("[Cart] @onUserOptionChanged #index:", index);
    // finding corresponding key in the object that matches the order index 
    let options = this.state.userOptions;
    // console.log("[Cart] @onUserOptionChanged #options:", options);
    let workflowOptions = this.state.screenData.options;
    // console.log("[Cart] @onUserOptionChanged #workflowOptions:", workflowOptions);
    const key = Object.keys(workflowOptions).find(key => workflowOptions[key].order === options[index].order);
    // console.log("[Cart] @onUserOptionChanged #key:", key);
    // changing options and modifying workflow
    // clearing all options and setting the selected one
    options.map(opt => {  // for current screen usage
      opt.enabled = 0;
    });
    // to update the workflow
    Object.keys(workflowOptions).map(k => { // for updating the complete w.f.
      workflowOptions[k].enabled = 0;
    })
    // setting the selected option
    options[index].enabled = 1;
    workflowOptions[key].enabled = 1;
    // console.log("[Cart] @onUserOptionChanged #workflowOptions:", workflowOptions);
    // console.log("[Cart] @onUserOptionChanged #options:", options);
    // update current screen
    this.setState({ userOptions: options });
    // updating wf
    let screenData = this.state.screenData;
    screenData.options = workflowOptions;
    // console.log("[Cart] @onUserOptionChanged #screenData:", screenData);
    this.update();
  }

  // deleting a skier from cart by changing a flag and notifying the server
  removeSkierFromCart = (option) => {
    this.setState({ skierToBeDeleted: option, errorFlg: false, alertElimination: true });
  }
  // deleting a skier from cart by changing a flag and notifying the server
  deleteSkier = (option) => {
    //console.log("[Cart] @removeSkierFromCart #option:", option);
    //console.log("[Cart] @removeSkierFromCart #screenData:", this.state.screenData);
    // find objext key by index
    let workflowOptions = this.state.screenData.options;
    let key = Object.keys(workflowOptions).find(key => workflowOptions[key] === option);
    //console.log("[Cart] @removeSkierFromCart #key:", key);
    workflowOptions[key].to_delete = 1;
    this.update();
  }

  applyCoupon = (e) => {
    e.preventDefault();
    let couponCode = document.getElementById("cart-coupon-code").value;
    //console.log("[Cart] @applyCoupon #couponCode:", couponCode);
    console.log('entrahhto');
    let screenData = this.state.screenData;
    screenData.coupon = couponCode;
    // console.log("[Cart] @onUserOptionChanged #screenData:", screenData);
    this.update();
  }

  helpShowModal = (help_tag) => {
    MPWorkFlow.getInstance().workflowHelp(this, { tag: help_tag });
  }

  onBack = () => {
    //return this.props.history.push('/');
    this.transit(this.state.screenData.link_back);
  }

  addNewSkier = (e) => {
    e.preventDefault();
    this.transit(this.state.screenData.link_add);
  }
  gotoNextStage = (e) => {
    e.preventDefault();
    this.transit(this.state.screenData.link_next);
  }

  render() {
    return (
      <Router>
        {
          this.state.screenData &&
          <div>
            <div>
              <div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
                <div className="row flex-nowrap">
                  <div className="col-2 d-flex align-items-center">
                    <button className="sn_btnbox" onClick={this.onBack}><img className="sn_mobile_top_row_arrow" src={miniArrow} /></button>
                  </div>
                  <div className="col-8 d-flex align-items-center justify-content-center">
                    <img className="sn_mobile_top_row_logo" src={logo} />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-end">
                    <button className="sn_btnbox" onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img className="sn_mobile_top_row_quest" src={help} /></button>
                  </div>
                </div>
              </div>
              <div className="sn_topbar"><TopBar step={this.state.step} /></div>
              <div className="sn_overlay d-lg-none"></div>
              <div className="sn_card">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-10 mx-auto">
                      <div className="sn_register__container p-3 p-md-4 p-lg-5" style={this.state.hidePay ? { display: 'none' } : {}}>
                        <div className="row mb-4 mb-lg-0 mt-3 mt-lg-0 d-none d-lg-flex">
                          <div className="col-12 d-flex justify-content-between justify-content-lg-end align-items-center">
                            {
                              this.state.screenData && this.state.screenData.help_tag &&
                              <div className="sn_quest">
                                <a onClick={() => this.helpShowModal(this.state.screenData.help_tag)}>
                                  <img src={help} />
                                </a>
                              </div>
                            }
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <h3 className="text-center mb-4">
                              {this.state.screenData && HtmlWrapper(this.state.screenData.title)}
                            </h3>
                            <h5 className="text-center">
                              {this.state.screenData && HtmlWrapper(this.state.screenData.desc)}
                            </h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            {
                              this.state.userOptions && this.state.userOptions.map((option, index) => {
                                return <UserSkiCards
                                  key={`user-cart-key-${index}`}
                                  id={`user-cart-${index}`}
                                  option={option}
                                  onChange={this.onUserOptionChanged}
                                  delete_label={this.state.screenData.delete_label}
                                  remove={this.removeSkierFromCart}
                                />
                              })
                            }
                          </div>
                        </div>
                        <div className="row mb-4 text-center">
                          <div className="col-12">
                            <p>{HtmlWrapper(this.state.screenData.note)}</p>
                          </div>
                        </div>
                        <div className="row mb-5">
                          <div className="col-12 col-md-10 mx-auto">
                            <div className="sn_card__container__bar">
                              <input
                                id="cart-coupon-code"
                                className="sn_card__container__bar__input"
                                spellCheck={false}
                                placeholder={this.state.screenData.coupon_pholder}
                                defaultValue={this.state.screenData.coupon}
                              />
                              <div onClick={this.applyCoupon}
                                className="sn_card__container__bar__apply">
                                {HtmlWrapper(this.state.screenData.coupon_button)}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-5">
                          <div className="col-12 col-md-10 mx-auto">
                            {
                              this.state.userTotals &&
                              this.state.userTotals.map((total, index) => {
                                if (index < this.state.userTotalsLastIndex) {
                                  return (
                                    <div className="row" key={"price-info-row-" + index}>
                                      <div className="col-12 d-flex justify-content-between">
                                        <h6>{HtmlWrapper(total.desc)}</h6>
                                        <h6>{HtmlWrapper(total.value)}</h6>
                                      </div>
                                    </div>
                                  )
                                }
                                else {
                                  return (
                                    this.state.userTotals &&
                                    <div className="row" key={"price-info-row-" + index}>
                                      <div className="col-12">
                                        <div className="sn_card__container__total">
                                          <h5>{HtmlWrapper(this.state.userTotals[this.state.userTotalsLastIndex].desc)}</h5>
                                          <h5>{HtmlWrapper(this.state.userTotals[this.state.userTotalsLastIndex].value)}</h5>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                }
                              })
                            }
                          </div>
                        </div>
                        <div className="row mb-3 mb-lg-5">
                          <div className="col-12 d-flex justify-content-center">
                            {
                              this.state.screenData.link_add !== "" &&
                              <button disabled={this.state.screenData.link_add === ""} className="sn_btn sn_fit-btn sn_btn_standard" onClick={this.addNewSkier}>{this.state.screenData.add_button}</button>
                            }
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 d-flex justify-content-center justify-content-lg-end">
                            <button className="sn_btn mr-lg-3 mb-3 mb-lg-0 sn_fit-btn d-none d-lg-block" onClick={this.onBack}>{tr.t('back')}</button>
                            <button disabled={!this.state.canProceed} className="sn_btn sn_fit-btn" onClick={this.gotoNextStage}>{this.state.screenData && this.state.screenData.next_button}</button>
                          </div>
                        </div>
                        <div className="row d-lg-none mt-5">
                          <div className="col-12">
                            <ProgressBullets step={this.state.step} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {
                this.state.errorFlg ?
                  <div className="containerModal">
                    {
                      this.state.errorFlg ?
                        <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
              }
              {
                this.state.alertElimination ?
                  <div className="containerModal">
                    {
                      this.state.alertElimination ?
                        <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={tr.t("deletingTheSkier")} singlebtn={true} textbtn1={tr.t("Delete")} sizebtn={"medium"} option1={"eliminate"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
              }
            </div>
            <WaitLoad enable={this.state.workFlowInProgress} />
            {this.state.helpShow && <InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })} />}
          </div>
        }
      </Router>
    );
  }
}

export default Cart;

class UserSkiCards extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      refresh: true,
    }
    this.myRef = React.createRef();
    //console.log('[cart] UserSkiCards setValidImage #props', props);
  }

  componentDidMount() {
    this.setValidImage(this.props.option.icons, this.props.id);
  }

  onChange = (e) => {
    this.props.onChange(this.props.id);
  }

  setValidImage(images, id) {
    // TODO: fix this code
    if (!images) return;
    //console.log('[cart] UserSkiCards setValidImage #image', images);
    images.map((img, index) => {
      var request = new XMLHttpRequest();
      request.open('GET', img, true);
      request.onreadystatechange = function () {
        // console.log('[cart] UserSkiCards setValidImage #readyState', request.status);
        if (request.readyState === 4) {
          if (request.status === 404) {
            // console.warn('[cart] UserSkiCards setValidImage #image', "error");
            document.getElementById(`ski-card-icon-${id}-${index}`).src = noImage;
          }
          else {
            if (img === 'https://user.mypass.cc/exhibits/card_mypass.png')
              document.getElementById(`ski-card-icon-${id}-${index}`).src = CardSki1;
            if (img === 'https://user.mypass.cc/exhibits/card_paganella.jpg')
              document.getElementById(`ski-card-icon-${id}-${index}`).src = CardSki2;
          }
        }
      };
      request.send();
    })
  }

  render() {
    const hasCardCodes = this.props.option.cardcodes && this.props.option.cardcodes.length > 0;
    return (
      <div>
        <div className="row justify-content-center mb-2">
          <div className="col-12 col-md-10 d-flex justify-content-between">
            <h6>{HtmlWrapper(this.props.option.header)}</h6>
            <h6 onClick={() => this.props.remove(this.props.option)} className="sn_underline">{HtmlWrapper(this.props.delete_label)}</h6>
          </div>
        </div>
        {
          isBrowser ?
            <div className="row justify-content-center">
              <div className="col-12 col-md-10">
                <div className="sn_card__container__desccard p-3 p-md-4 mb-4">
                  <div className="row">
                    <div className="col-4 d-flex flex-wrap">
                      {
                        this.props.option.icons &&
                        this.props.option.icons.map((icon, index) => {
                          return <img
                            key={index}
                            id={`ski-card-icon-${this.props.id}-${index}`}
                            className="cart-ski-card-icons"
                          />
                        })
                      }
                    </div>
                    <div className="col-8 col-sm-5 d-flex flex-column">
                      <p>
                        {HtmlWrapper(this.props.option.cardholder_label + ":")}<br />
                        <strong>{HtmlWrapper(this.props.option.cardholder)}</strong>
                      </p>
                      <p>
                        {HtmlWrapper(this.props.option.category_label + ":")}<br />
                        <strong>{HtmlWrapper(this.props.option.category)}</strong>
                      </p>

                      <p>
                        {HtmlWrapper(this.props.option.state_label + ":")}<br />
                        <strong>{HtmlWrapper(this.props.option.state)}</strong>
                      </p>

                      <p>
                        {hasCardCodes && HtmlWrapper(this.props.option.cardcodes_label + ":")}
                        {
                          hasCardCodes && this.props.option.cardcodes.map((code, index) => {
                            return <div id={"blah-blah-" + index}>
                              {HtmlWrapper(code)}
                            </div>
                          })
                        }
                      </p>
                    </div>
                    <div className="col-12 col-sm-3">
                      <p className="text-nw text-right text-lg-left">{HtmlWrapper(this.props.option.amount)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            :
            <div className="row justify-content-center">
              <div className="col-12 col-md-10">
                <div className="sn_card__container__desccard p-3 p-md-4 mb-4">
                  <div className="row">
                    <div className="col-4 d-flex flex-wrap">
                      {
                        this.props.option.icons &&
                        this.props.option.icons.map((icon, index) => {
                          return <img
                            key={index}
                            id={`ski-card-icon-${this.props.id}-${index}`}
                            className="cart-ski-card-icons"
                          />
                        })
                      }
                    </div>
                    <div className="col-5 d-flex flex-column">
                      <p>
                        {HtmlWrapper(this.props.option.cardholder_label + ":")}<br />
                        <strong>{HtmlWrapper(this.props.option.cardholder)}</strong>
                      </p>
                      <p>
                        {HtmlWrapper(this.props.option.category_label + ":")}<br />
                        <strong>{HtmlWrapper(this.props.option.category)}</strong>
                      </p>

                      <p>
                        {HtmlWrapper(this.props.option.state_label + ":")}<br />
                        <strong>{HtmlWrapper(this.props.option.state)}</strong>
                      </p>

                      <p>
                        {hasCardCodes && HtmlWrapper(this.props.option.cardcodes_label + ":")}
                        {
                          hasCardCodes && this.props.option.cardcodes.map((code, index) => {
                            return <div id={"blah-blah-" + index}>
                              {HtmlWrapper(code)}
                            </div>
                          })
                        }
                      </p>
                    </div>
                    <div className="col-3">
                      {HtmlWrapper(this.props.option.amount)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/Cart/Cart.js